import { createContext, useContext, useState, useCallback } from 'react';

const STORAGE_KEY = 'tmstudio_admin_token';
const STORAGE_REFRESH = 'tmstudio_admin_refresh';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [idToken, setIdToken] = useState(() => sessionStorage.getItem(STORAGE_KEY));

  const login = useCallback(async (email, password) => {
    const res = await fetch('/api/auth', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.error || 'Login failed');
    sessionStorage.setItem(STORAGE_KEY, data.idToken);
    sessionStorage.setItem(STORAGE_REFRESH, data.refreshToken || '');
    setIdToken(data.idToken);
    return data;
  }, []);

  const logout = useCallback(() => {
    sessionStorage.removeItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_REFRESH);
    setIdToken(null);
  }, []);

  const getAuthHeader = useCallback(() => {
    const t = idToken || sessionStorage.getItem(STORAGE_KEY);
    return t ? { Authorization: `Bearer ${t}` } : {};
  }, [idToken]);

  const isAuthenticated = Boolean(idToken || (typeof window !== 'undefined' && sessionStorage.getItem(STORAGE_KEY)));

  return (
    <AuthContext.Provider value={{ login, logout, getAuthHeader, idToken, isAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) return { login: async () => {}, logout: () => {}, getAuthHeader: () => ({}), idToken: null, isAuthenticated: false };
  return ctx;
}
